import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
class CropUpload extends React.Component {
    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
        this.handleFile = this.handleFile.bind(this);
    }
    handleFile(e) {
        const reader = new FileReader();
        const file = e.target.files[0];
        if (!file) {
            return;
        }
        reader.onload = (img) => {
            if (this.fileInput && this.fileInput.current) {
                this.fileInput.current.focus();
                this.fileInput.current.value = '';
                this.props.handleFileChange(img.target.result);
            }
        };
        reader.readAsDataURL(file);
    }
    render() {
        return (_jsx("input", { ref: this.fileInput, type: "file", accept: "image/*", id: this.props.handleIdName, onChange: this.handleFile }));
    }
}
CropUpload.defaultProps = {
    handleIdName: 'crop-upload',
};
export default CropUpload;
